import React from 'react';
import { Button } from '@mui/material';
import { trakrefBlue } from '../../color_utils';
import PropTypes from 'prop-types';

const SimpleButton = ({
    text,
    redirectLink,
    onClick,
    disabled,
    variant,
    customStyle,
}) => {
    // const classes = useStyles();
    const variantContainedStyle = variant === "contained"
        ? {
            backgroundColor: trakrefBlue,
            color: '#fff',
    
            "&:hover": {
                color: "white"
            }
        }
        : {}; 
    return (
        <Button
            variant={variant}
            href={redirectLink}
            size="small"
            onClick={onClick}
            disabled={disabled}
            sx={{
                ...variantContainedStyle,
                ...customStyle
            }}
        >
            {text}
        </Button>
    );
};

SimpleButton.propTypes = {
    text: PropTypes.string.isRequired,
    redirectLink: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    variant: PropTypes.string,
};

SimpleButton.defaultProps = {
    redirectLink: '',
    disabled: false,
    variant: "contained",
};

export default SimpleButton;
